import { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { LanguageProvider } from "@/i18n";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Operazioni from "@/pages/Operazioni";
import Valorizzazione from "@/pages/Valorizzazione";
import SaldoStralcio from "@/pages/SaldoStralcio";
import Ristrutturazioni from "@/pages/Ristrutturazioni";
import GeneralContractor from "@/pages/GeneralContractor";
import Consulenza from "@/pages/Consulenza";
import ChiSiamo from "@/pages/ChiSiamo";
import Contatti from "@/pages/Contatti";
import { PrivacyPage, CookiePage } from "@/pages/Legali";

function ScrollManager() {
  const { pathname } = useLocation();
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    lenisRef.current?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollManager />
        <div className="min-h-screen bg-ivory">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/operazioni-immobiliari" element={<Operazioni />} />
              <Route path="/valorizzazione" element={<Valorizzazione />} />
              <Route path="/ristrutturazioni" element={<Ristrutturazioni />} />
              <Route path="/general-contractor" element={<GeneralContractor />} />
              <Route path="/saldo-e-stralcio" element={<SaldoStralcio />} />
              <Route path="/consulenza" element={<Consulenza />} />
              <Route path="/chi-siamo" element={<ChiSiamo />} />
              <Route path="/contatti" element={<Contatti />} />
              <Route path="/privacy-policy" element={<PrivacyPage />} />
              <Route path="/cookie-policy" element={<CookiePage />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
